import { render, staticRenderFns } from "./PlantillaImpresionTemporal.vue?vue&type=template&id=2ddf87de&scoped=true&"
import script from "./PlantillaImpresionTemporal.vue?vue&type=script&lang=js&"
export * from "./PlantillaImpresionTemporal.vue?vue&type=script&lang=js&"
import style0 from "./PlantillaImpresionTemporal.vue?vue&type=style&index=0&id=2ddf87de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddf87de",
  null
  
)

export default component.exports